module.exports = __webpack_public_path__ + "static/img/ys_logo_primary-black.dc79528.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ys_logo_primary-black.svg
// module id = 44
// module chunks = 180